import { createActions } from 'redux-actions';

export const {
  getAllSignatures,
  getAllSignaturesSuccess,
  getAllSignaturesFailure,
} = createActions(
  'GET_ALL_SIGNATURES',
  'GET_ALL_SIGNATURES_SUCCESS',
  'GET_ALL_SIGNATURES_FAILURE'
);
